import carsJson from "../data/cars.json";
import driversJson from "../data/drivers.json";
import simJson from "../data/sim.json";
import scoringJson from "../data/scoring.json";
import bayshoreLoop from "../data/tracks/bayshore-loop.json";
import { carsSchema, driversSchema, scoringSchema, simTuningSchema, trackSchema } from "./schemas";

export * from "./schemas";

export const cars = carsSchema.parse(carsJson);
export const drivers = driversSchema.parse(driversJson);
export const simTuning = simTuningSchema.parse(simJson);
export const scoring = scoringSchema.parse(scoringJson);
export const tracks = [trackSchema.parse(bayshoreLoop)];
